import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';

const initialState = fromJS({
    list: {
        isLoading: false,
        data: null
    }
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // device types
        case CONSTANTS.ON_DEVICE_TYPES_LIST_IS_LOADING:
            return state.setIn(['list', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_DEVICE_TYPES_LIST:
            return state.setIn(['list', 'data'], payload.data);

        default:
            return state;
    }
};

export default reducer;
